import { render, staticRenderFns } from "./PdpDefaultV3.vue?vue&type=template&id=be949e24&scoped=true"
import script from "./PdpDefaultV3.vue?vue&type=script&lang=js"
export * from "./PdpDefaultV3.vue?vue&type=script&lang=js"
import style0 from "./PdpDefaultV3.vue?vue&type=style&index=0&id=be949e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be949e24",
  null
  
)

export default component.exports